import clsx from 'clsx';

export const PROGRESSBAR_RISK = 0;
export const PROGRESSBAR_VALIDATION = 1;

/*
size = small/large
color = tailwind color class
bgColor = tailwind color class
 */
export const ProgressBar = ({ value, size = 'large', height = null, color = PROGRESSBAR_RISK, bgColor = 'gray-200', className, ...props }) => {
  const heightClass = height !== null ? height : size === 'large' ? 'h-4' : 'h-2';
  const bgColorClass = 'bg-' + bgColor;

  let colorClass = 'bg-perception-blue';
  if (color === PROGRESSBAR_RISK) colorClass = value >= 60 ? 'bg-error' : value >= 30 ? 'bg-warning' : 'bg-success';
  else if (color === PROGRESSBAR_VALIDATION) colorClass = value < 34 ? 'bg-error' : value < 67 ? 'bg-warning' : 'bg-success';

  const css = { width: value + '%' };

  return (
    <div className={clsx(heightClass, bgColorClass, className, 'overflow-hidden rounded-full')}>
      <div
        style={color === PROGRESSBAR_RISK || color === PROGRESSBAR_VALIDATION ? css : {...css, background: color} }
        className={clsx(colorClass, 'duration-500 ease-linear h-full rounded-full')}
      />
    </div>
  );
};
